export const PASSWORD_REQUIREMENTS =
  "Use at least 8 characters, including an uppercase letter, a lowercase letter, and a number."

export function isValidPassword(password) {
  return password.length >= 8
    && /[A-Z]/.test(password)
    && /[a-z]/.test(password)
    && /[0-9]/.test(password)
}